export default __webpack_public_path__ + "static/media/towers-of-hanoi.03a5f368.png";